module.exports = __webpack_public_path__ + "static/media/activity_type_kinderen.7f31a491.svg";